import Input from "./Input";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import DatePicker from "./DatePicker";
import CheckBox from "./Checkbox";
import Button from "./Button";
import ActionButton from "./ActionButton";
import PasswordInput from "./PasswordInput";
import IconButton from "./IconButton";
import CustomizedSwitches from "./Switch";
const Controls = {
    Input,
    RadioGroup,
    Select,
    DatePicker,
    CheckBox,
    Button,
    ActionButton,
    PasswordInput,
    IconButton,
    CustomizedSwitches
};

export default Controls;